import ManageSubadmins from "layouts/subadmin/ManageSubadmins";
import Subadmin from "layouts/subadmin/Subadmin";
import ProtectedRoute from "routes/protectedRoutes.js";

const SubadminRoutes = [

  {
    route: "subadmin/edit/:subadminId",
    key: "EditRole",
    component: <ProtectedRoute check="logout"><Subadmin  /></ProtectedRoute>
  },
  {
    route: "/subadmin/manage/:pageNo",
    key: "manage-subadmin",
    component: <ProtectedRoute check="logout"><ManageSubadmins /></ProtectedRoute>
  }
  ];

export default SubadminRoutes;
